import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import OrderItem from "./OrderItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import {LIST_ORDERS_FOR_ACCOUNT} from "../../queries/sales";
import {requestViewChargePayments} from "../../actions/AccountApiActions";
import PaginatorButton from "../../components/PaginatorButton";

class OrderList extends Component {

  render() {
    let params = {filter: {accountId: this.props.accountId}}
    let tableHeader = List([
      "Order #",
      "Billing Name",
      "Order Date",
      "Paid Date",
      "Total",
      "Status",
      "",
      ""
    ])              
    return (
      <Query query={LIST_ORDERS_FOR_ACCOUNT} variables={params}>
        {({ loading, error, data, fetchMore }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let orders = fromJS(data.salesOrders.entries);
          if (orders.size === 0) {
            return <EmptyStatus status="No orders found" />
          }

          function handleNext(afterId) {
            fetchMore({
              variables: {
                pagination: {
                  after: afterId
                }
              },
              updateQuery: (prev, {fetchMoreResult}) => {
                if (!fetchMoreResult) return prev;
                return {
                  salesOrders: {
                    __typename: prev.salesOrders.__typename,
                    metadata: fetchMoreResult.salesOrders.metadata,
                    entries: [...prev.salesOrders.entries, ...fetchMoreResult.salesOrders.entries]
                  }
                }
              }
            })
          }            

          return (
            <div>
              <Table 
                data={orders} 
                mode="table"
                renderer={OrderItem} 
                tableHeader={tableHeader}
                itemKey="orderId"
                onContextMenuClick={this.handleContextMenuClick.bind(this)}
                />
              <PaginatorButton 
                metadata={fromJS(data.salesOrders.metadata)} 
                onNext={handleNext}
                />

            </div>
          )
        }}
      </Query>
    )
  }

  handleContextMenuClick(id) {
    this.props.requestViewChargePayments(this.props.accountId, id);
  }
}

OrderList.defaultProps = {
  accountId: ""
}

export default connect(null, {requestViewChargePayments})(OrderList);